var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c("div", { staticClass: "filter-container-content" }, [
        _c("div", { staticClass: "user-form-content" }, [
          _c("div", { staticClass: "form-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("userCenter.userInfo.baseInfoTitle")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-input-content" },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "userInfoRef",
                      attrs: {
                        model: _vm.userInfo,
                        rules: _vm.userInfoRules,
                        "label-width": "200px",
                        "label-position": "top",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item-bottom",
                                  attrs: {
                                    label: _vm.$t(
                                      "userCenter.userInfo.accountInfo"
                                    ),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.userInfo.accountNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.userInfo, "accountNo", $$v)
                                      },
                                      expression: "userInfo.accountNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item-bottom",
                                  attrs: {
                                    label: _vm.$t(
                                      "userCenter.userInfo.userName"
                                    ),
                                    prop: "accountName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.userInfo.accountName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.userInfo,
                                          "accountName",
                                          $$v
                                        )
                                      },
                                      expression: "userInfo.accountName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item-bottom",
                                  attrs: {
                                    label: _vm.$t(
                                      "userCenter.userInfo.activateEmail"
                                    ),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.userInfo.activateEmail,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.userInfo,
                                          "activateEmail",
                                          $$v
                                        )
                                      },
                                      expression: "userInfo.activateEmail",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item-bottom",
                                  attrs: {
                                    label: _vm.$t(
                                      "userCenter.userInfo.simisCompanyCode"
                                    ),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.userInfo.simisCompanyCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.userInfo,
                                          "simisCompanyCode",
                                          $$v
                                        )
                                      },
                                      expression: "userInfo.simisCompanyCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item-bottom",
                                  attrs: {
                                    label: _vm.$t(
                                      "userCenter.userInfo.simisCompanyNameCn"
                                    ),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.userInfo.simisCompanyNameCn,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.userInfo,
                                          "simisCompanyNameCn",
                                          $$v
                                        )
                                      },
                                      expression: "userInfo.simisCompanyNameCn",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item-bottom",
                                  attrs: {
                                    label: _vm.$t(
                                      "userCenter.userInfo.simisCompanyNameEn"
                                    ),
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.userInfo.simisCompanyNameEn,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.userInfo,
                                          "simisCompanyNameEn",
                                          $$v
                                        )
                                      },
                                      expression: "userInfo.simisCompanyNameEn",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "regired form-item-bottom",
                          attrs: {
                            label: _vm.$t("userCenter.userInfo.notifyToEmail"),
                            prop: "notifyToEmail",
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.userInfo.notifyToEmail,
                              callback: function ($$v) {
                                _vm.$set(_vm.userInfo, "notifyToEmail", $$v)
                              },
                              expression: "userInfo.notifyToEmail",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            prop: "notifyCcEmail",
                            label: _vm.$t("userCenter.userInfo.notifyCcEmail"),
                          },
                        },
                        [
                          _c("el-input", {
                            model: {
                              value: _vm.userInfo.notifyCcEmail,
                              callback: function ($$v) {
                                _vm.$set(_vm.userInfo, "notifyCcEmail", $$v)
                              },
                              expression: "userInfo.notifyCcEmail",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item-bottom",
                          attrs: {
                            label: _vm.$t(
                              "userCenter.userInfo.bookingViewType"
                            ),
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.userInfo.bookingViewType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userInfo, "bookingViewType", $$v)
                                },
                                expression: "userInfo.bookingViewType",
                              },
                            },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: 0 },
                                  model: {
                                    value: _vm.userInfo.bookingViewType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.userInfo,
                                        "bookingViewType",
                                        $$v
                                      )
                                    },
                                    expression: "userInfo.bookingViewType",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("userCenter.userInfo.cardRadio")
                                    ) + "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: 1 },
                                  model: {
                                    value: _vm.userInfo.bookingViewType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.userInfo,
                                        "bookingViewType",
                                        $$v
                                      )
                                    },
                                    expression: "userInfo.bookingViewType",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("userCenter.userInfo.listRadio")
                                    ) + "\n                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _vm.registerTermContent
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "registerText",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleOpen("1")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.registerAgreement"))
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.bookingTermContent
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "registerText",
                                    staticStyle: { "margin-left": "10px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleOpen("2")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.bookingAgreement"))
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-dialog",
                            {
                              staticClass: "descriTion",
                              attrs: {
                                "close-on-click-modal": false,
                                visible: _vm.dialogVisible,
                                width: "80%",
                              },
                              on: {
                                "update:visible": function ($event) {
                                  _vm.dialogVisible = $event
                                },
                              },
                            },
                            [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.termContent),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filter-container-content" }, [
        _c("div", { staticClass: "user-form-content" }, [
          _c("div", { staticClass: "form-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("userCenter.userInfo.passwordInfoTitle")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-input-content" },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "resetPasswordRef",
                      attrs: {
                        model: _vm.resetPasswordForm,
                        rules: _vm.resetPasswordRules,
                        "label-width": "200px",
                        "label-position": "top",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item-bottom",
                                  attrs: {
                                    label: _vm.$t(
                                      "userCenter.userInfo.passwordInfo"
                                    ),
                                    prop: "password",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    key: _vm.passwordType,
                                    ref: "password",
                                    staticStyle: { width: "90%" },
                                    attrs: {
                                      type: _vm.passwordType,
                                      name: "password",
                                      tabindex: "2",
                                      maxlength: "30",
                                      autocomplete: "on",
                                      onpaste: "return true",
                                      oncopy: "return true",
                                      oncut: "return false",
                                      oncontextmenu: "return false",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        _vm.capsTooltip = false
                                      },
                                    },
                                    model: {
                                      value: _vm.resetPasswordForm.password,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.resetPasswordForm,
                                          "password",
                                          $$v
                                        )
                                      },
                                      expression: "resetPasswordForm.password",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "show-pwd",
                                      on: {
                                        mousedown: _vm.showPwd,
                                        mouseout: _vm.hidePwd,
                                        mouseup: _vm.hidePwd,
                                      },
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: {
                                          "icon-class":
                                            _vm.passwordType === "password"
                                              ? "eye"
                                              : "eye-open",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        { staticStyle: { "margin-top": "10px" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "form-item-bottom",
                                  attrs: {
                                    label: _vm.$t(
                                      "userCenter.userInfo.confirmPassword"
                                    ),
                                    prop: "confirmPassword",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    key: _vm.passwordTypeConfirm,
                                    ref: "password",
                                    staticStyle: { width: "90%" },
                                    attrs: {
                                      type: _vm.passwordTypeConfirm,
                                      name: "password",
                                      tabindex: "2",
                                      maxlength: "30",
                                      autocomplete: "on",
                                      onpaste: "return true",
                                      oncopy: "return true",
                                      oncut: "return false",
                                      oncontextmenu: "return false",
                                    },
                                    on: {
                                      blur: function ($event) {
                                        _vm.capsTooltip = false
                                      },
                                    },
                                    model: {
                                      value:
                                        _vm.resetPasswordForm.confirmPassword,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.resetPasswordForm,
                                          "confirmPassword",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "resetPasswordForm.confirmPassword",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "show-pwd",
                                      on: {
                                        mousedown: _vm.showPwdCon,
                                        mouseout: _vm.hidePwdCon,
                                        mouseup: _vm.hidePwdCon,
                                      },
                                    },
                                    [
                                      _c("svg-icon", {
                                        attrs: {
                                          "icon-class":
                                            _vm.passwordTypeConfirm ===
                                            "password"
                                              ? "eye"
                                              : "eye-open",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-item-center" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-primary",
              staticStyle: { width: "288px" },
              attrs: { type: "primary", disabled: _vm.isChangeEdit == false },
              on: { click: _vm.submitForm },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("userCenter.userInfo.submitButton")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }